import React from 'react'
import withAppdata from '../AppConfig/withAppdata'
import { Button } from 'reactstrap'
import SettingsIcon from '@mui/icons-material/Settings'
import VenuemanagerPrsonalPreferencesDialog from '../Dialogs/VenuemanagerPersonalPreferencesDialog'

function PersonalPreferencesButton({ appdata, iconOnly }) {
  const [open, setOpen] = React.useState(false)

  const toggle = () => {
    console.log('toggling personal preferences dialog')
    setOpen(!open)
  }
  return (
    <>
      <VenuemanagerPrsonalPreferencesDialog appdata={appdata} toggle={toggle} isOpen={open} />
        <Button size='sm' onClick={() => toggle()} title={iconOnly ? 'Omat asetukset' : undefined}>
          {' '}
          <SettingsIcon fontSize='small' />{iconOnly ? '' : ' Omat asetukset'}
      </Button>
      </>
      )
}

export default withAppdata(PersonalPreferencesButton)
